module.exports = __webpack_public_path__ + "static/media/p1.fcc6132c.jpg";